import { IConfig } from "./types";

// Domínios white-label onde certas features do portal ficam ocultas (hotfix):
// o item de menu "Acesso à conta" e os simuladores de venda/recebimento não
// devem aparecer nem ser acessíveis por URL direta nesses domínios.
export const HIDDEN_FEATURE_DOMAINS = ["portal.reevopag.com"];

// True quando o host atual está na allowlist de domínios com features ocultas.
export const isHiddenFeatureDomain = (): boolean =>
  HIDDEN_FEATURE_DOMAINS.includes(window.location.hostname);

// BFF do Portal: intermedia as chamadas aos micro serviços (struct, flux, gcb,
// slc, reg, kaptor), escondendo clientId/clientSecret.
// Todos os domínios já estão no Front Door, com /api e /auth servidos no MESMO host
// do portal (same-origin). Por isso o BFF é sempre chamado por URL relativa: o cookie
// bff.session é first-party e o Safari/iOS não o bloqueia (ITP).
// Dev local (localhost): descomente a linha abaixo.
// const bffUrl = "https://localhost:61962";
const bffUrl = "";

const Config: IConfig = {
  bffUrl,
  // Usuario de servico do BFF: existe um por ambiente, cada um validado contra o
  // Bff:Auth:Users do Key Vault do proprio ambiente (kv-valori-hml / kv-valori).
  // Por isso vive aqui, junto das outras URLs que variam por branch.
  //   HML .....: portal.hml  (Key Vault kv-valori-hml)
  //   Producao : portal.prd  (Key Vault kv-valori)
  // Mandar o usuario de um ambiente para o BFF do outro derruba o login inteiro:
  // 401 ate o throttle virar 429, e nenhuma rota de negocio passa do [Authorize].
  bffUsername: "portal.prd",
  bffPassword: "PortalPrd@2026!",
  // apiBaseUrl: 'https://localhost:44371/api',
  apiBaseUrl: "https://api-app-service-prod.azurewebsites.net/api",
  ibgeBaseUrl: "https://servicodados.ibge.gov.br/api",
  viaCepBaseUrl: "https://viacep.com.br/ws",
  // wlBaseurl: 'http://localhost:8383/api',
  wlBaseurl: "https://link.valori.com.vc:8485/api",
  pagamentosUrl: "https://link.valori.com.vc:8486/api",
  apiRiscoUrl: "https://risco.valori.com.vc:8284/api"
};

export default Config;
